import React from 'react'
import './Meeting.scss'

const Meeting = () => {
  return (
    <div>Meeting</div>
  )
}

export default Meeting